import LinkButton from "../../menu/link-button/link-button";
import React from "react";
import { TextBox } from "@/components/primitives/text-box";

type Props = {
  header: string;
  linkPath?: string;
  subHeader?: React.ReactNode;
};

const HeaderContent = ({
  linkPath,
  text,
}: {
  linkPath?: string;
  text: string;
}) => {
  if (linkPath) {
    return (
      <LinkButton path={linkPath} className={"w-full"} size={"4xl"}>
        {text}
      </LinkButton>
    );
  } else {
    return (
      <div className={"bg-gray-drk shadow-basic text-center text-4xl p-1"}>
        {text}
      </div>
    );
  }
};

const StyledHeader: React.FC<Props> = (props) => {
  return (
    <div className={"flex flex-col flex-1 font-sans"}>
      <div className={"uppercase"}>
        <HeaderContent text={props.header} linkPath={props.linkPath} />
      </div>
      {props.subHeader && (
        <TextBox
          variant="primary"
          size="lg"
          spacing="base"
          textClassName="!text-center"
        >
          {props.subHeader}
        </TextBox>
      )}
    </div>
  );
};

export default StyledHeader;
